// Clear search input

export function clearInput() {
  const clearButton = document.getElementById("clear-input");
  const myInput = document.getElementById("s");

  if (clearButton && myInput) {
    myInput.addEventListener("input", function () {
      if (myInput.value.trim() !== "") {
        clearButton.classList.remove("hidden");
      } else {
        clearButton.classList.add("hidden");
      }
    });

    clearButton.addEventListener("click", function () {
      myInput.value = "";
      clearButton.classList.add("hidden");
      myInput.focus();
    });
  }
}
